// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1pzux","file":"styles_file__3PsXj"};